import { styled } from 'styled-components';

const CardStyle = styled.div`
  .myProductCard {
    .ant-card-body {
      padding: 0;
    }
  }
`;
export default CardStyle;
